import { graphql } from '../../graphql/graphql';
import { buttonFragment } from '../../graphql/fragments/buttonFragment';
import { dynamicContentFragment } from '../../graphql/fragments/dynamicContentFragment';

export const beforeYouBuyTimelineQuery = graphql(
  `
    query BeforeYouBuyTimeline($propertyId: String!, $toggleBYBLegalDisclaimers: Boolean = false) {
      beforeYouBuyV2(propertyId: $propertyId) {
        ...BeforeYouBuyWithoutModal
      }
    }

    fragment BeforeYouBuyWithoutModal on BeforeYouBuy {
      propertyPageTimelineBrick @skip(if: $toggleBYBLegalDisclaimers) {
        title
        subtitle
        disclaimer {
          ...DynamicContent
        }
        reportCTAV2 {
          ...Button
        }
      }
      propertyPageTimelineBrickV3 @include(if: $toggleBYBLegalDisclaimers) {
        title
        subtitle
        disclaimer {
          ...DynamicContent
        }
        reportCTA {
          ...Button
        }
      }
    }
  `,
  [buttonFragment, dynamicContentFragment],
);
